import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'center',
    width: '44px',
    height: '100%',
    borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
    zIndex: 5,
    overflow: 'hidden',
  },
  containerEnabled: {
    backgroundColor: '#D6D6FB',
  },
  containerDisabled: {
    backgroundColor: '#BABBC9',
  },
  scoreList: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
  },
  arrowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#D6D6FB',
    width: '42px',
    zIndex: 10,
  },
  arrowIcon: {
    position: 'relative',
    width: '12px',
    height: '12px',
    margin: '5px',
    cursor: 'pointer',
  },
}));
